/* global axios */
import ApiClient from './ApiClient';

class PipelinesAPI extends ApiClient {
  constructor() {
    super('pipelines', { accountScoped: true });
  }

  urlForAccount(accountId) {
    const normalizedAccountId =
      accountId === undefined || accountId === null
        ? ''
        : String(accountId).trim();
    if (!normalizedAccountId) {
      throw new TypeError('accountId is required');
    }

    return `${this.apiVersion}/accounts/${encodeURIComponent(normalizedAccountId)}/${this.resource}`;
  }

  async get(accountId) {
    return axios.get(this.urlForAccount(accountId));
  }

  async create(data, accountId) {
    return axios.post(this.urlForAccount(accountId), data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  async delete(id, accountId) {
    return axios.delete(`${this.urlForAccount(accountId)}/${id}`);
  }

  async update(id, data, accountId) {
    return axios.patch(`${this.urlForAccount(accountId)}/${id}`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
}

export default new PipelinesAPI();
